// extracted by mini-css-extract-plugin
export default {"dependency-name":"IOFDaFsd59jC6DodM5g1","linking":"QKgQygsMOub8gKRZsDhA","licenses":"xt05Q0K3rlhZHmymIx0e","highlight":"fJpDrJRmnMgi17KT1mQU"};